import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import logError from 'src/utils/logError';

import ActivityLogBase from '../../Helpers/ActivityLogBase';
import { useAiAgentLabel } from '../../Helpers/useAiAgentLabel';
import ActivityLogFeedSlackMessage from '../ActivityLogFeedSlackMessage';

interface Fragments {
  activityLog: ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment;
}

type EmployeeSlackMessageReceivedDetails = {
  __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails';
  employeeName: string;
  body: string;
};

const ActivityLogEmployeeSlackMessageReceived: FCWithFragments<Fragments> = ({ activityLog }) => {
  const aiAgentLabel = useAiAgentLabel();
  const details = activityLog.details as unknown as EmployeeSlackMessageReceivedDetails | null | undefined;

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename !== 'ActivityLogEmployeeSlackMessageReceivedDetails') {
    logError('ActivityLogEmployeeSlackMessageReceived: details is not ActivityLogEmployeeSlackMessageReceivedDetails');
    return null;
  }

  const { body, employeeName: detailsEmployeeName } = details;
  const employeeName = activityLog.actorEmployee?.fullName ?? detailsEmployeeName;
  return (
    <ActivityLogBase activityLog={activityLog} actorName={employeeName} actionLabel="replied via a Slack message">
      <ActivityLogFeedSlackMessage fromName={employeeName} toName={aiAgentLabel} body={body} />
    </ActivityLogBase>
  );
};

ActivityLogEmployeeSlackMessageReceived.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogEmployeeSlackMessageReceived_activityLog on ActivityLog {
      id
      activityType
      details {
        ... on ActivityLogEmployeeSlackMessageReceivedDetails {
          __typename
          employeeId
          employeeName
          channelId
          threadTs
          messageTs
          body
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogEmployeeSlackMessageReceived;
